import { render, staticRenderFns } from "./viewLoteAnimal.vue?vue&type=template&id=47bb4769&scoped=true"
import script from "./viewLoteAnimal.vue?vue&type=script&lang=js"
export * from "./viewLoteAnimal.vue?vue&type=script&lang=js"
import style0 from "./viewLoteAnimal.vue?vue&type=style&index=0&id=47bb4769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb4769",
  null
  
)

export default component.exports